<div *ngIf="network" fxLayout="column" class="plannings-container">
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="24px">
        <div class="txt-s-16-4">
            {{'Time range'|i18n}}:
        </div>
        <div>
            <app-time-filter [profile]="TimeFilterProfile.PLANNING"
                             [defaultType]="DEFAULT_TIME_FILTER"
                             (timeFilterChange)="onSelectTimeFilter($event)">
            </app-time-filter>
        </div>
    </div>
    <div class="plannings-panel mt-20">
        <ng-container *ngIf="plannings; else loadingPlannings">
            <div fxLayout="row" fxLayoutAlign="space-between center"
                 [ngClass]="{'mb-18': !!plannings.total || network.plannable}">
                <div class="txt-h-18-7">
                    <ng-container *ngIf="!!plannings.total">
                        {{'Plannings'|i18n}}
                    </ng-container>
                </div>
                <button *ngIf="network.plannable" app-small-ghost-button class="new-planning-button"
                        [disabled]="!network.operatable"
                        (click)="onClickNewPlanning()">
                    <app-icon name="fal-chart-bar"></app-icon>&nbsp;&nbsp;
                    {{'New planning'|i18n}}
                </button>
            </div>
            <div *ngIf="!plannings.total" fxLayoutAlign="center">
                {{'No plannings found'|i18n}}
            </div>
            <mat-accordion>
                <mat-expansion-panel *ngFor="let planning of plannings.plannings; trackBy: trackByPlanningId"
                                     togglePosition="before">
                    <mat-expansion-panel-header [title]="'Planning details'|i18n">
                        <mat-panel-title>
                            <div fxLayout="row" fxLayoutAlign="space-between center" class="planning">
                                <div fxLayout="row" fxLayoutAlign="start center">
                                    <div class="mr-12">
                                        <app-icon class="planning-status-icon"
                                                  [ngClass]="{'text-primary': planning.status === PlanningStatus.OK,
                                                              'text-light-warning': planning.status === PlanningStatus.IMPOSSIBLE,
                                                              'text-warning': planning.status === PlanningStatus.FAIL }"
                                                  [name]="planning.status|planningStatusIcon">
                                        </app-icon>
                                    </div>
                                    <div class="txt-p-14-4 mr-24 planning-timestamp">
                                        {{planning.planning_timestamp|i18nTimestamp}}
                                    </div>
                                    <div class="txt-p-14-4">
                                        {{(planning|planningStrategy) + ' ' + ('planning')|i18n}}
                                    </div>
                                </div>
                                <button app-icon-button class="view-planning-button"
                                        [title]="'View planning'|i18n"
                                        (click)="onClickGotoPlanning(planning.id, $event)">
                                    <app-icon name="fal-arrow-right"></app-icon>
                                </button>
                            </div>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <app-planning-details [planning]="planning">
                    </app-planning-details>
                </mat-expansion-panel>
            </mat-accordion>
        </ng-container>
        <mat-paginator #paginator app-paginator class="plannings-paginator"
                       [ngClass]="{'collapsed': !plannings || plannings.total === 0}"
                       [length]="plannings?.total" [pageSize]="PAGE_SIZE"
                       [pageSizeOptions]="PAGE_SIZES">
        </mat-paginator>
    </div>
</div>

<ng-template #loadingPlannings>
    <div fxLayout="row" fxLayoutAlign="center center">
        <mat-spinner app-spinner diameter="20"></mat-spinner>
        <span class="pl-8">{{'Loading plannings'|i18n}}...</span>
    </div>
</ng-template>
